/* tslint:disable */
/* eslint-disable */
/**
 * Credify API doc version 1
 * API documentations version 1.
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: dev@credify.one
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ApprovalsListResponse } from '../model';
// @ts-ignore
import { CommonResponse } from '../model';
// @ts-ignore
import { OIDCAuthorizationRequest } from '../model';
// @ts-ignore
import { OIDCAuthorizationRequestWithoutLoginChallenge } from '../model';
// @ts-ignore
import { OIDCClientsResponse } from '../model';
// @ts-ignore
import { OIDCInfoResponse } from '../model';
// @ts-ignore
import { OIDCUserInfoResponse } from '../model';
/**
 * OIDCApi - axios parameter creator
 * @export
 */
export const OIDCApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This operation authorizes the integrating platform to use user\'s Credify entity on the platform. This is to be requested by each individual entity with their access token.  `approval_token` contains `scopes`, which is a list of scopes that users are going to share with the OIDC client. This `scopes` might contain some custom scopes provided by claim providers, and in that case Credify will fetch the custom claim values from the claim provider.  `values` has encrypted standard & passive claim values with the OIDC client\'s public key. Each field is encrypted. 
         * @summary Authorize OIDC without Login challenge
         * @param {OIDCAuthorizationRequestWithoutLoginChallenge} oIDCAuthorizationRequestWithoutLoginChallenge 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeOidc: async (oIDCAuthorizationRequestWithoutLoginChallenge: OIDCAuthorizationRequestWithoutLoginChallenge, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'oIDCAuthorizationRequestWithoutLoginChallenge' is not null or undefined
            assertParamExists('authorizeOidc', 'oIDCAuthorizationRequestWithoutLoginChallenge', oIDCAuthorizationRequestWithoutLoginChallenge)
            const localVarPath = `/v1/oidc/applications/authorize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = oIDCAuthorizationRequestWithoutLoginChallenge

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation authorizes the integrating platform to use user\'s Credify entity on the platform. This is to be requested by each individual entity with their access token.  `code` is a login challenge generated by Hydra.  `approval_token` contains `scopes`, which is a list of scopes that users are going to share with the OIDC client. This `scopes` might contain some custom scopes provided by claim providers, and in that case Credify will fetch the custom claim values from the claim provider.  `values` has encrypted standard & passive claim values with the OIDC client\'s public key. Each field is encrypted. 
         * @summary Authorize OIDC with Login challenge
         * @param {string} code Login challenge generated in Hydra
         * @param {OIDCAuthorizationRequest} oIDCAuthorizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeOidcWithLoginChallenge: async (code: string, oIDCAuthorizationRequest: OIDCAuthorizationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('authorizeOidcWithLoginChallenge', 'code', code)
            // verify required parameter 'oIDCAuthorizationRequest' is not null or undefined
            assertParamExists('authorizeOidcWithLoginChallenge', 'oIDCAuthorizationRequest', oIDCAuthorizationRequest)
            const localVarPath = `/v1/oidc/applications/{code}/authorize`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = oIDCAuthorizationRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation requests to fetch encrypted scope values shared by users with an OIDC client. The OIDC client needs to use an ephemeral private key generated in the OIDC flow to decrypt the values. The response body will contain encrypted custom claim values as well as the standard claims.
         * @summary Encrypted scope values shared by users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncryptedScopeValue: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/oidc/userinfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns a list of OIDC approvals of the calling individual.  `offer` and `dispute` are optional. 
         * @summary OIDC approval list
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [offerCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOidcApprovalList: async (page?: number, limit?: number, offerCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/approvals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offerCode !== undefined) {
                localVarQueryParameter['offer_code'] = offerCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns OIDC applications with published status.
         * @summary OIDC applications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOidcInfo: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/oidc/applications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns OIDC application a user is going to log in.
         * @summary OIDC application info with login code
         * @param {string} code Login challenge generated in Hydra
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOidcInfoWithLoginChallenge: async (code: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('getOidcInfoWithLoginChallenge', 'code', code)
            const localVarPath = `/v1/oidc/applications/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation deauthorizes the integrating platform to use user\'s Credify entity on the platform. `id` is Application id.
         * @summary Removal of authorization of the connected OIDC app
         * @param {number} id Application ID
         * @param {string} scopeDisplayName Application display name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAuthorization: async (id: number, scopeDisplayName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeAuthorization', 'id', id)
            // verify required parameter 'scopeDisplayName' is not null or undefined
            assertParamExists('removeAuthorization', 'scopeDisplayName', scopeDisplayName)
            const localVarPath = `/v1/oidc/applications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (scopeDisplayName !== undefined) {
                localVarQueryParameter['scope_display_name'] = scopeDisplayName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OIDCApi - functional programming interface
 * @export
 */
export const OIDCApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OIDCApiAxiosParamCreator(configuration)
    return {
        /**
         * This operation authorizes the integrating platform to use user\'s Credify entity on the platform. This is to be requested by each individual entity with their access token.  `approval_token` contains `scopes`, which is a list of scopes that users are going to share with the OIDC client. This `scopes` might contain some custom scopes provided by claim providers, and in that case Credify will fetch the custom claim values from the claim provider.  `values` has encrypted standard & passive claim values with the OIDC client\'s public key. Each field is encrypted. 
         * @summary Authorize OIDC without Login challenge
         * @param {OIDCAuthorizationRequestWithoutLoginChallenge} oIDCAuthorizationRequestWithoutLoginChallenge 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authorizeOidc(oIDCAuthorizationRequestWithoutLoginChallenge: OIDCAuthorizationRequestWithoutLoginChallenge, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorizeOidc(oIDCAuthorizationRequestWithoutLoginChallenge, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This operation authorizes the integrating platform to use user\'s Credify entity on the platform. This is to be requested by each individual entity with their access token.  `code` is a login challenge generated by Hydra.  `approval_token` contains `scopes`, which is a list of scopes that users are going to share with the OIDC client. This `scopes` might contain some custom scopes provided by claim providers, and in that case Credify will fetch the custom claim values from the claim provider.  `values` has encrypted standard & passive claim values with the OIDC client\'s public key. Each field is encrypted. 
         * @summary Authorize OIDC with Login challenge
         * @param {string} code Login challenge generated in Hydra
         * @param {OIDCAuthorizationRequest} oIDCAuthorizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authorizeOidcWithLoginChallenge(code: string, oIDCAuthorizationRequest: OIDCAuthorizationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorizeOidcWithLoginChallenge(code, oIDCAuthorizationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This operation requests to fetch encrypted scope values shared by users with an OIDC client. The OIDC client needs to use an ephemeral private key generated in the OIDC flow to decrypt the values. The response body will contain encrypted custom claim values as well as the standard claims.
         * @summary Encrypted scope values shared by users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEncryptedScopeValue(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OIDCUserInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEncryptedScopeValue(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns a list of OIDC approvals of the calling individual.  `offer` and `dispute` are optional. 
         * @summary OIDC approval list
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [offerCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOidcApprovalList(page?: number, limit?: number, offerCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApprovalsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOidcApprovalList(page, limit, offerCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns OIDC applications with published status.
         * @summary OIDC applications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOidcInfo(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OIDCClientsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOidcInfo(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns OIDC application a user is going to log in.
         * @summary OIDC application info with login code
         * @param {string} code Login challenge generated in Hydra
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOidcInfoWithLoginChallenge(code: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OIDCInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOidcInfoWithLoginChallenge(code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This operation deauthorizes the integrating platform to use user\'s Credify entity on the platform. `id` is Application id.
         * @summary Removal of authorization of the connected OIDC app
         * @param {number} id Application ID
         * @param {string} scopeDisplayName Application display name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeAuthorization(id: number, scopeDisplayName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeAuthorization(id, scopeDisplayName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OIDCApi - factory interface
 * @export
 */
export const OIDCApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OIDCApiFp(configuration)
    return {
        /**
         * This operation authorizes the integrating platform to use user\'s Credify entity on the platform. This is to be requested by each individual entity with their access token.  `approval_token` contains `scopes`, which is a list of scopes that users are going to share with the OIDC client. This `scopes` might contain some custom scopes provided by claim providers, and in that case Credify will fetch the custom claim values from the claim provider.  `values` has encrypted standard & passive claim values with the OIDC client\'s public key. Each field is encrypted. 
         * @summary Authorize OIDC without Login challenge
         * @param {OIDCAuthorizationRequestWithoutLoginChallenge} oIDCAuthorizationRequestWithoutLoginChallenge 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeOidc(oIDCAuthorizationRequestWithoutLoginChallenge: OIDCAuthorizationRequestWithoutLoginChallenge, options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.authorizeOidc(oIDCAuthorizationRequestWithoutLoginChallenge, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation authorizes the integrating platform to use user\'s Credify entity on the platform. This is to be requested by each individual entity with their access token.  `code` is a login challenge generated by Hydra.  `approval_token` contains `scopes`, which is a list of scopes that users are going to share with the OIDC client. This `scopes` might contain some custom scopes provided by claim providers, and in that case Credify will fetch the custom claim values from the claim provider.  `values` has encrypted standard & passive claim values with the OIDC client\'s public key. Each field is encrypted. 
         * @summary Authorize OIDC with Login challenge
         * @param {string} code Login challenge generated in Hydra
         * @param {OIDCAuthorizationRequest} oIDCAuthorizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeOidcWithLoginChallenge(code: string, oIDCAuthorizationRequest: OIDCAuthorizationRequest, options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.authorizeOidcWithLoginChallenge(code, oIDCAuthorizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation requests to fetch encrypted scope values shared by users with an OIDC client. The OIDC client needs to use an ephemeral private key generated in the OIDC flow to decrypt the values. The response body will contain encrypted custom claim values as well as the standard claims.
         * @summary Encrypted scope values shared by users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncryptedScopeValue(options?: any): AxiosPromise<OIDCUserInfoResponse> {
            return localVarFp.getEncryptedScopeValue(options).then((request) => request(axios, basePath));
        },
        /**
         * This returns a list of OIDC approvals of the calling individual.  `offer` and `dispute` are optional. 
         * @summary OIDC approval list
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [offerCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOidcApprovalList(page?: number, limit?: number, offerCode?: string, options?: any): AxiosPromise<ApprovalsListResponse> {
            return localVarFp.getOidcApprovalList(page, limit, offerCode, options).then((request) => request(axios, basePath));
        },
        /**
         * This returns OIDC applications with published status.
         * @summary OIDC applications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOidcInfo(options?: any): AxiosPromise<OIDCClientsResponse> {
            return localVarFp.getOidcInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * This returns OIDC application a user is going to log in.
         * @summary OIDC application info with login code
         * @param {string} code Login challenge generated in Hydra
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOidcInfoWithLoginChallenge(code: string, options?: any): AxiosPromise<OIDCInfoResponse> {
            return localVarFp.getOidcInfoWithLoginChallenge(code, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation deauthorizes the integrating platform to use user\'s Credify entity on the platform. `id` is Application id.
         * @summary Removal of authorization of the connected OIDC app
         * @param {number} id Application ID
         * @param {string} scopeDisplayName Application display name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAuthorization(id: number, scopeDisplayName: string, options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.removeAuthorization(id, scopeDisplayName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OIDCApi - interface
 * @export
 * @interface OIDCApi
 */
export interface OIDCApiInterface {
    /**
     * This operation authorizes the integrating platform to use user\'s Credify entity on the platform. This is to be requested by each individual entity with their access token.  `approval_token` contains `scopes`, which is a list of scopes that users are going to share with the OIDC client. This `scopes` might contain some custom scopes provided by claim providers, and in that case Credify will fetch the custom claim values from the claim provider.  `values` has encrypted standard & passive claim values with the OIDC client\'s public key. Each field is encrypted. 
     * @summary Authorize OIDC without Login challenge
     * @param {OIDCAuthorizationRequestWithoutLoginChallenge} oIDCAuthorizationRequestWithoutLoginChallenge 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OIDCApiInterface
     */
    authorizeOidc(oIDCAuthorizationRequestWithoutLoginChallenge: OIDCAuthorizationRequestWithoutLoginChallenge, options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

    /**
     * This operation authorizes the integrating platform to use user\'s Credify entity on the platform. This is to be requested by each individual entity with their access token.  `code` is a login challenge generated by Hydra.  `approval_token` contains `scopes`, which is a list of scopes that users are going to share with the OIDC client. This `scopes` might contain some custom scopes provided by claim providers, and in that case Credify will fetch the custom claim values from the claim provider.  `values` has encrypted standard & passive claim values with the OIDC client\'s public key. Each field is encrypted. 
     * @summary Authorize OIDC with Login challenge
     * @param {string} code Login challenge generated in Hydra
     * @param {OIDCAuthorizationRequest} oIDCAuthorizationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OIDCApiInterface
     */
    authorizeOidcWithLoginChallenge(code: string, oIDCAuthorizationRequest: OIDCAuthorizationRequest, options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

    /**
     * This operation requests to fetch encrypted scope values shared by users with an OIDC client. The OIDC client needs to use an ephemeral private key generated in the OIDC flow to decrypt the values. The response body will contain encrypted custom claim values as well as the standard claims.
     * @summary Encrypted scope values shared by users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OIDCApiInterface
     */
    getEncryptedScopeValue(options?: AxiosRequestConfig): AxiosPromise<OIDCUserInfoResponse>;

    /**
     * This returns a list of OIDC approvals of the calling individual.  `offer` and `dispute` are optional. 
     * @summary OIDC approval list
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {string} [offerCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OIDCApiInterface
     */
    getOidcApprovalList(page?: number, limit?: number, offerCode?: string, options?: AxiosRequestConfig): AxiosPromise<ApprovalsListResponse>;

    /**
     * This returns OIDC applications with published status.
     * @summary OIDC applications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OIDCApiInterface
     */
    getOidcInfo(options?: AxiosRequestConfig): AxiosPromise<OIDCClientsResponse>;

    /**
     * This returns OIDC application a user is going to log in.
     * @summary OIDC application info with login code
     * @param {string} code Login challenge generated in Hydra
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OIDCApiInterface
     */
    getOidcInfoWithLoginChallenge(code: string, options?: AxiosRequestConfig): AxiosPromise<OIDCInfoResponse>;

    /**
     * This operation deauthorizes the integrating platform to use user\'s Credify entity on the platform. `id` is Application id.
     * @summary Removal of authorization of the connected OIDC app
     * @param {number} id Application ID
     * @param {string} scopeDisplayName Application display name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OIDCApiInterface
     */
    removeAuthorization(id: number, scopeDisplayName: string, options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

}

/**
 * OIDCApi - object-oriented interface
 * @export
 * @class OIDCApi
 * @extends {BaseAPI}
 */
export class OIDCApi extends BaseAPI implements OIDCApiInterface {
    /**
     * This operation authorizes the integrating platform to use user\'s Credify entity on the platform. This is to be requested by each individual entity with their access token.  `approval_token` contains `scopes`, which is a list of scopes that users are going to share with the OIDC client. This `scopes` might contain some custom scopes provided by claim providers, and in that case Credify will fetch the custom claim values from the claim provider.  `values` has encrypted standard & passive claim values with the OIDC client\'s public key. Each field is encrypted. 
     * @summary Authorize OIDC without Login challenge
     * @param {OIDCAuthorizationRequestWithoutLoginChallenge} oIDCAuthorizationRequestWithoutLoginChallenge 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OIDCApi
     */
    public authorizeOidc(oIDCAuthorizationRequestWithoutLoginChallenge: OIDCAuthorizationRequestWithoutLoginChallenge, options?: AxiosRequestConfig) {
        return OIDCApiFp(this.configuration).authorizeOidc(oIDCAuthorizationRequestWithoutLoginChallenge, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation authorizes the integrating platform to use user\'s Credify entity on the platform. This is to be requested by each individual entity with their access token.  `code` is a login challenge generated by Hydra.  `approval_token` contains `scopes`, which is a list of scopes that users are going to share with the OIDC client. This `scopes` might contain some custom scopes provided by claim providers, and in that case Credify will fetch the custom claim values from the claim provider.  `values` has encrypted standard & passive claim values with the OIDC client\'s public key. Each field is encrypted. 
     * @summary Authorize OIDC with Login challenge
     * @param {string} code Login challenge generated in Hydra
     * @param {OIDCAuthorizationRequest} oIDCAuthorizationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OIDCApi
     */
    public authorizeOidcWithLoginChallenge(code: string, oIDCAuthorizationRequest: OIDCAuthorizationRequest, options?: AxiosRequestConfig) {
        return OIDCApiFp(this.configuration).authorizeOidcWithLoginChallenge(code, oIDCAuthorizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation requests to fetch encrypted scope values shared by users with an OIDC client. The OIDC client needs to use an ephemeral private key generated in the OIDC flow to decrypt the values. The response body will contain encrypted custom claim values as well as the standard claims.
     * @summary Encrypted scope values shared by users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OIDCApi
     */
    public getEncryptedScopeValue(options?: AxiosRequestConfig) {
        return OIDCApiFp(this.configuration).getEncryptedScopeValue(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns a list of OIDC approvals of the calling individual.  `offer` and `dispute` are optional. 
     * @summary OIDC approval list
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {string} [offerCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OIDCApi
     */
    public getOidcApprovalList(page?: number, limit?: number, offerCode?: string, options?: AxiosRequestConfig) {
        return OIDCApiFp(this.configuration).getOidcApprovalList(page, limit, offerCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns OIDC applications with published status.
     * @summary OIDC applications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OIDCApi
     */
    public getOidcInfo(options?: AxiosRequestConfig) {
        return OIDCApiFp(this.configuration).getOidcInfo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns OIDC application a user is going to log in.
     * @summary OIDC application info with login code
     * @param {string} code Login challenge generated in Hydra
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OIDCApi
     */
    public getOidcInfoWithLoginChallenge(code: string, options?: AxiosRequestConfig) {
        return OIDCApiFp(this.configuration).getOidcInfoWithLoginChallenge(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation deauthorizes the integrating platform to use user\'s Credify entity on the platform. `id` is Application id.
     * @summary Removal of authorization of the connected OIDC app
     * @param {number} id Application ID
     * @param {string} scopeDisplayName Application display name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OIDCApi
     */
    public removeAuthorization(id: number, scopeDisplayName: string, options?: AxiosRequestConfig) {
        return OIDCApiFp(this.configuration).removeAuthorization(id, scopeDisplayName, options).then((request) => request(this.axios, this.basePath));
    }
}
